import Token from '../../data/models/Token';
export var login = function login(data) {
  var _data$login;
  return {
    token: Token(data == null ? void 0 : data.login),
    user: data == null ? void 0 : (_data$login = data.login) == null ? void 0 : _data$login.user
  };
};